import { useTranslation } from "react-i18next";
import { ReactComponent as Logo } from "shared/assets/images/logo-strm-horizontal.svg";
import { ReactComponent as LogoTemp } from "shared/assets/images/logo-strm.svg";
import { ReactComponent as IconMenu } from "shared/assets/images/menu.svg";
import { ReactComponent as IconMeusDados } from "shared/assets/images/icon-meus-dados.svg";
import IconMeusDadosSrc from "shared/assets/images/icon-meus-dados.svg";
import { ReactComponent as IconLogout } from "shared/assets/images/icon-logout.svg";
import { ReactComponent as HomeIcon } from "shared/assets/images/icon-home.svg";
import { ReactComponent as QuincyIcon } from "shared/assets/images/quincy-icon.svg";
import { ReactComponent as IconMetas } from "shared/assets/images/icon-metas.svg";
import { ReactComponent as DiagnosticoIcon } from "shared/assets/images/icon-diagnostic.svg";
import { ReactComponent as MenuIcon } from "shared/assets/images/icon-menu.svg";
import { useState, useRef } from "react";
import { Layout, Menu, Popover } from "antd";
import { isMobile } from "react-device-detect";
import ContentMenu from "./MenuContent";
import { Link, useHistory } from "react-router-dom";
import { logout } from "shared/helpers/auth-functions";
import { useSelector } from "react-redux";
import "./MenuLateral.scss";
import ArtistMetrics from "../artist-metrics/ArtistMetrics";
import { useFlags } from "launchdarkly-react-client-sdk";
import { dataLayerClickedEvent } from "event-tracker/gtm-events";
import { MenuButtonClickEventName } from "event-tracker/button-click-event-name";
import SubscriptionDefaultCTA from "../subscription/SubscriptionDefaultCTA";
import MyPlan from "../subscription/MyPlan";
import { isEnableFullDiagnostic } from "shared/helpers/full-diagnostic-helpers";

const { Header } = Layout;

const CustomLevelSvg = ({ level }: { level: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="30"
    viewBox="0 0 28 30"
    fill="none"
  >
    <g filter="url(#filter0_i_17683_2023)">
      <path
        d="M10.0882 1.59846C12.4584 0.0240096 15.5416 0.024008 17.9118 1.59846L23.9625 5.61771C25.8045 6.8413 26.9679 8.85634 27.1065 11.0634L27.562 18.3131C27.7404 21.153 26.1988 23.823 23.6502 25.0885L17.1441 28.3189C15.1634 29.3024 12.8366 29.3024 10.8559 28.3189L4.34983 25.0885C1.8012 23.823 0.259626 21.153 0.43803 18.3131L0.893457 11.0634C1.03211 8.85634 2.19548 6.84131 4.03752 5.61771L10.0882 1.59846Z"
        fill="#242366"
      />
    </g>
    <path
      d="M10.6416 2.43164C12.613 1.12213 15.1587 1.08092 17.166 2.30859L17.3584 2.43164L23.4092 6.4502C24.8917 7.43499 25.8625 9.01737 26.0762 10.7725L26.1084 11.126L26.5635 18.376C26.7118 20.7379 25.475 22.9634 23.4082 24.0879L23.2051 24.1924L16.6992 27.4229C15.105 28.2144 13.2499 28.2639 11.623 27.5713L11.3008 27.4229L4.79492 24.1924C2.67506 23.1398 1.36609 20.9558 1.42578 18.6035L1.43652 18.376L1.8916 11.126C2.00322 9.34965 2.88763 7.71786 4.30078 6.65527L4.59082 6.4502L10.6416 2.43164Z"
      stroke="url(#paint0_linear_17683_2023)"
      strokeWidth="2"
    />
    <text
      x="14"
      y="21"
      textAnchor="middle"
      fill="#F2F2F2"
      fontSize="16"
      fontWeight="700"
      fontFamily="Cabin"
    >
      {level}
    </text>
    <defs>
      <filter
        id="filter0_i_17683_2023"
        x="0.423828"
        y="0.417603"
        width="27.1523"
        height="30.1273"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.48837" />
        <feGaussianBlur stdDeviation="5.02326" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0597531 0 0 0 0 0.0574266 0 0 0 0 0.173756 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_17683_2023"
        />
      </filter>
      <linearGradient
        id="paint0_linear_17683_2023"
        x1="14"
        y1="-1"
        x2="14"
        y2="31"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9B3DE" />
        <stop offset="1" stopColor="#4846CC" />
      </linearGradient>
    </defs>
  </svg>
);

declare global {
  interface Window {
    flutter_inappwebview: any;
  }
}

const MenuLateral: React.FC = () => {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState<boolean>(true);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [isMainMenuOpen, setIsMainMenuOpen] = useState<boolean>(false);
  const [openProfile, setOpenProfile] = useState<boolean>(false);
  const profileMenuRef = useRef<HTMLDivElement | null>(null);
  const { userArtist } = useSelector((state: any) => state.artists);
  let { titulo } = t(
    `pages.EstagioArtista.estagio.${userArtist?.stage || 0}`
  ) as any;
  const history = useHistory();
  const { metricsMenu, showHome } = useFlags();

  const signOutClickHandler = () => logout(false);

  const handleMouseEnter = () => {
    setCollapsed(false);
  };

  const handleMouseLeave = () => {
    setCollapsed(true);
  };

  const closeProfileMenu = () => {
    setOpenProfile(false);
  };

  const onClickOpenMenu = () => {
    setMenuOpen(true);
    dataLayerClickedEvent(MenuButtonClickEventName.OPEN_MENU, {
      businessContext: "TOOLBAR",
      platformContext: "S4A",
    });
  };

  const onClickOpenProfile = () => {
    setOpenProfile(!openProfile);
    if (openProfile) {
      dataLayerClickedEvent(MenuButtonClickEventName.PROFILE, {
        businessContext: "TOOLBAR",
        platformContext: "S4A",
      });
    }
  };

  // useEffect(() => {
  //   if (!openProfile) return;
  //   function handleClickOutside(event: MouseEvent) {
  //     if (
  //       profileMenuRef.current &&
  //       !profileMenuRef.current.contains(event.target as Node)
  //     ) {
  //       setOpenProfile(false);
  //     }
  //   }
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [openProfile]);

  if (isMobile)
    return (
      <>
        <div
          className={`menu content-menu  mobile ${
            collapsed ? "collapsed" : ""
          }`}
        >
          <div className="menu-top">
            {!metricsMenu && (
              <div className="item">
                <LogoTemp
                  style={{ width: 48 }}
                  onClick={() => history.push("/")}
                />
              </div>
            )}
            {metricsMenu && <ArtistMetrics />}

            <div
              className="last"
              style={{ marginLeft: 6 }}
              onClick={onClickOpenProfile}
            >
              {userArtist ? (
                <div className="image">
                  <img src={userArtist?.profileImage} alt="" />
                  <span className="estagio">{userArtist?.stage}</span>
                </div>
              ) : (
                <div className="image">
                  <img src={IconMeusDadosSrc} alt="" />
                  <span className="estagio">-</span>
                </div>
              )}
            </div>
          </div>
          {openProfile && (
            <div
              ref={profileMenuRef}
              style={{ width: "100%", backgroundColor: "#242366" }}
            >
              <div className="menu-list">
                <div style={{ padding: "0 16px" }}>
                  <MyPlan />
                </div>
                <div
                  className={`menu-item${
                    history?.location?.pathname === "/meus-dados"
                      ? " selected"
                      : ""
                  }`}
                >
                  <Link to="/meus-dados" onClick={closeProfileMenu}>
                    <IconMeusDados />
                    <span>{t("components.MenuLateral.meusDados")}</span>
                  </Link>
                </div>

                <div className="menu-item" onClick={signOutClickHandler}>
                  <IconLogout />
                  <span>{t("components.MenuLateral.sair")}</span>
                </div>
              </div>
            </div>
          )}
        </div>
        {!menuOpen && (
          <nav className="bottom-nav-bar">
            <Link
              to={showHome ? "/" : "/estagio"}
              className="nav-btn"
              onClick={closeProfileMenu}
            >
              <HomeIcon stroke="#bcb8f7" />
            </Link>
            <Link to="/metas" className="nav-btn" onClick={closeProfileMenu}>
              <IconMetas stroke="#bcb8f7" />
            </Link>
            {isEnableFullDiagnostic(userArtist) && (
              <Link
                to="/diagnosticos"
                className="nav-btn"
                onClick={closeProfileMenu}
              >
                <DiagnosticoIcon stroke="#bcb8f7" />
              </Link>
            )}
            <Link to="/quincy" className="nav-btn" onClick={closeProfileMenu}>
              <QuincyIcon fill="#bcb8f7" width={21} />
            </Link>
            <button className="nav-btn" onClick={onClickOpenMenu}>
              <IconMenu fill="#bcb8f7" />
            </button>
          </nav>
        )}
        {menuOpen && (
          <ContentMenu onCloseMenu={() => setMenuOpen(false)} fullScreen />
        )}
      </>
    );

  return (
    <Header
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="menu"
      style={{
        justifyContent: "space-between",
        position: "sticky",
        top: 0,
        zIndex: 9999,
        width: "100%",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        onClick={() => history.push("/")}
      >
        <Logo />
        <span
          style={{
            marginTop: 8,
            marginLeft: 12,
            color: "#F2F2F2",
            fontSize: 12,
            lineHeight: "100%",
          }}
        >
          for artists
        </span>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        {metricsMenu && (
          <div className="artist-metrics-wrapper">
            <ArtistMetrics />
          </div>
        )}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            cursor: "pointer",
          }}
          onClick={() => history.push("/estagio")}
        >
          <CustomLevelSvg level={userArtist?.stage || 0} />
          <span className="body-regular" style={{ fontWeight: 700 }}>
            {titulo}
          </span>
        </div>
        <div style={{ width: 100 }}>
          <span
            style={{
              marginBottom: 4,
              lineHeight: 1,
              display: "block",
            }}
            className="body-small"
          >
            {`${(userArtist?.stagePercentual || 0).toFixed(0)}% `}
          </span>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <div
              style={{
                height: 4,
                width: `${userArtist?.stagePercentual || 0}%`,
                backgroundColor: "#00D88A",
                borderRadius:
                  userArtist?.stagePercentual === 100
                    ? "3px"
                    : "3px 0px 0px 3px",
              }}
            />
            <div
              style={{
                height: 4,
                width: `${100 - (userArtist?.stagePercentual || 0)}%`,
                backgroundColor: "#1B1A4C",
                borderRadius: "0px 3px 3px 0px",
              }}
            />
          </div>
        </div>
        <SubscriptionDefaultCTA />
        <Popover
          classNames={{
            root: "popover-menu",
          }}
          trigger={"click"}
          open={isMainMenuOpen}
          onOpenChange={(open) => {
            setIsMainMenuOpen(open);
            if (open) {
              dataLayerClickedEvent(MenuButtonClickEventName.PROFILE, {
                businessContext: "TOOLBAR",
                platformContext: "S4A",
              });
            }
          }}
          content={<ContentMenu onCloseMenu={() => setIsMainMenuOpen(false)} />}
        >
          <span style={{ display: "flex", cursor: "pointer" }}>
            <MenuIcon />
          </span>
        </Popover>

        <Popover
          classNames={{
            root: "popover-menu",
          }}
          styles={{
            root: {
              width: 250,
              top: 60,
            },
          }}
          arrowContent={null}
          trigger={"click"}
          onOpenChange={(open) => {
            if (open) {
              dataLayerClickedEvent(MenuButtonClickEventName.OPEN_MENU, {
                businessContext: "TOOLBAR",
                platformContext: "S4A",
              });
            }
          }}
          content={
            <div>
              <MyPlan />
              <Menu
                mode="vertical"
                selectedKeys={[history?.location?.pathname]}
                items={[
                  {
                    label: (
                      <Link to="/meus-dados">
                        {t("components.MenuLateral.meusDados")}
                      </Link>
                    ),
                    key: "/meus-dados",
                    icon: <IconMeusDados />,
                  },
                  {
                    label: t("components.MenuLateral.sair"),
                    key: "logout",
                    icon: <IconLogout />,
                    onClick: signOutClickHandler,
                  },
                ]}
              />
            </div>
          }
        >
          {userArtist?.id ? (
            <div className="image">
              <img src={userArtist?.profileImage} alt="" />
            </div>
          ) : (
            <div className="image">
              <img src={IconMeusDadosSrc} alt="" />
              <span className="estagio">-</span>
            </div>
          )}
        </Popover>
      </div>
    </Header>
  );
};

export default MenuLateral;
